import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenServiceService } from './token-service.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface ResponseEmailController {
  order: string,
  email: string,
  attemps: number
}
@Injectable({
  providedIn: 'root'
})
export class DepositsManageService {

  constructor(
    private readonly http: HttpClient,
    private readonly tokenServiceService: TokenServiceService,
  ) { }

  private serviceLink = `${environment.urlglobal_api}/api/v3/checkout/emailregcontroller`;

  public consultOrder(order: string) {
    const req = {
      order
    };
    const token = this.tokenServiceService.getToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token,
      }),
    };
    return this.http.post(`${this.serviceLink}`, req, httpOptions);
  }
  /**
   * @description {sendEmailWithLimit} Service to send transaction email with rate limit 
  */
  sendEmailWithLimit(order: string, email: string): Observable<ResponseEmailController> {
    const req = { order, email, url: location.href };
    const token = this.tokenServiceService.getToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token,
      }),
    };
    return this.http.post<ResponseEmailController>(`${this.serviceLink}`, req, httpOptions)
      .pipe(map((res: ResponseEmailController) => res));
  }

}
